module.exports = __webpack_public_path__ + "static/heatmaps-f44481cf6f69dbd7ef2de7f97aea124e.png";